// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.list-solicitation {
  min-height: 100vh;
}
`, "",{"version":3,"sources":["webpack://./src/Assets/styles/default/pages/listSolicitation/ListSolicitation.less"],"names":[],"mappings":"AAAA;EACE,iBAAA;AACF","sourcesContent":[".list-solicitation {\n  min-height: 100vh;\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
